if (!customElements.get('fade-in-list')) {
    customElements.define('fade-in-list', class FadeInList extends HTMLElement {
        constructor() {
            super();

            this.elements = {
                list: this.querySelector('.fade-in-list__items'),
                listItems: this.querySelectorAll('.fade-in-list__item'),
                visible: false,
            };

            if (this.elements.list && this.elements.listItems && this.elements.listItems.length > 0) {
                this.listItemsUpdate();
                window.addEventListener('scroll', this.listItemsUpdate.bind(this));
                window.addEventListener('resize', this.listItemsUpdate.bind(this));
            }
        }

        listItemsUpdate() {
            const isElementVisible = window.isElementVisible(this.elements.list);

            if (this.elements.visible !== isElementVisible) {
                for (let i = 0; i < this.elements.listItems.length; i++) {
                    window.setTimeout(() => {
                        if (isElementVisible) {
                            this.elements.listItems[i].classList.add('fade-in-list__item--show');
                        } else {
                            this.elements.listItems[i].classList.remove('fade-in-list__item--show');
                        }
                    }, 350 * i);

                    window.setTimeout(() => {
                        this.elements.visible = isElementVisible;
                    }, 350 * i);
                }
            }
        }
    });
}
